import React from "react";

export const SEChevronRight = ({ color = "#222222", ...props }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			color={color}
			{...props}
		>
			<path
				d="M10.5005 7.29979C10.5005 7.08472 10.4184 6.86968 10.2545 6.70572L5.09471 1.54597C4.76648 1.21775 4.23432 1.21775 3.90623 1.54597C3.57813 1.87407 3.57813 2.40613 3.90623 2.73438L8.4719 7.29979L3.90639 11.8652C3.57829 12.1934 3.57829 12.7254 3.90639 13.0535C4.23448 13.3819 4.76664 13.3819 5.09487 13.0535L10.2547 7.89386C10.4186 7.72981 10.5005 7.51477 10.5005 7.29979Z"
				fill="currentColor"
			/>
		</svg>
	);
};
